"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertMenuItemInfoToGeneric = void 0;
var TextMenuDisplayFormatter_1 = require("./ListMenuDisplayFormatters/TextMenuDisplayFormatter");
/**
 * This converts the original dropdowns with only text values to use the displayFormatter
 */
exports.convertMenuItemInfoToGeneric = function (basicMenuItemInfo, selectedValue) {
    return basicMenuItemInfo.map(function (basic) { return ({
        checked: (!!selectedValue && basic.value === selectedValue) || basic.checked,
        disabled: basic.disabled,
        displayFormatterBoundWithData: TextMenuDisplayFormatter_1.TextMenuDisplayFormatter(basic.displayValue, basic.title),
        isDivider: basic.isDivider,
        isGroup: basic.isGroup,
        isUnselectable: false,
        keyboardAccessibleValue: basic.displayValue,
        menuItemInfos: !!basic.menuItemInfos ? exports.convertMenuItemInfoToGeneric(basic.menuItemInfos) : undefined,
        subMenuMaxHeight: basic.subMenuMaxHeight,
        subMenuStyle: basic.subMenuStyle,
        textForDropdownButton: basic.displayValue,
        value: basic.value,
    }); });
};
//# sourceMappingURL=MenuItemInfo.js.map